import Vue from 'vue'
import VueGtm from 'vue-gtm'
import router from '../router'

Vue.use(VueGtm, {
  id: 'GTM-PL79K4N',
  debug: process.env.NODE_ENV !== 'production',
  vueRouter: router,
})
